import { NEUTRAL_300 } from "../../styles/colors"
import { INTER } from "../../styles/fonts"

const SectionLabel = ({ children, style }: { children: React.ReactNode, style?: React.CSSProperties }) => {
    return (
        <span
            style={{
                fontFamily: INTER.semiBold,
                fontSize: '14px',
                color: NEUTRAL_300,
                ...style
            }}
        >
            {children}
        </span>
    )
}

export default SectionLabel
